import { isBrowser } from '../constants';
import { publicApi } from './index';

export const editFileSettinsAPI = async (
  uuid: string,
  downloadable: boolean,
  recaptchaToken: string
) => {
  const body = new FormData();
  body.append('downloadable', downloadable ? 'true' : 'false');

  return publicApi.post(
    `/file/${uuid}/edit`,
    body,
    isBrowser && localStorage.getItem('token')
      ? {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            RecaptchaToken: recaptchaToken,
          },
        }
      : {}
  );
};
